const version = 'v1.0.79 buildID:79 2026-02-05 03:05:55'

if (version) {
  localStorage.setItem('rentalFrontVersion', version)
}
